import { createElementBlock as o, openBlock as l, createElementVNode as n } from "vue";
const t = {
  fill: "none",
  viewBox: "0 0 23 28"
};
function r(c, e) {
  return l(), o("svg", t, [...e[0] || (e[0] = [
    n("path", {
      fill: "#1258FF",
      "fill-rule": "evenodd",
      d: "M9.997 21.975V28s6.07-4.962 10.354-10.632c1.515-2.006 2.545-5.165 2.142-7.797-.877-5.728-5.589-9.69-11.425-9.568C4.957.13 0 4.92 0 10.989c0 9.569 9.997 10.986 9.997 10.986m1.293-5.348c3.118 0 5.646-2.486 5.646-5.552s-2.528-5.551-5.646-5.551-5.645 2.485-5.645 5.551 2.528 5.552 5.645 5.552",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
